import { Deserializable } from '../../../lib/models/deserializable';

export class RemortgageUse implements Deserializable {
  public OtherAdditionalRemortgage?: number;
  public ReMortgageAdditionalProperty?: number;
  public ReMortgageBusinessInvestment?: number;
  public ReMortgageCostsAndFees?: number;
  public ReMortgageHomeImprovement?: number;
  public ReMortgageLoanRepayment?: number;
  public ReMortgageOutrightPropertyPurchase?: number;
  public ReMortgageSchoolFeesOrPension?: number;
  public OtherAdditionalRemortgageDetails: string;
  public RemortgageUseID: number;
  public ReMortgageOtherPropertyImprovement?: number;
  public RedemptionMortgageOnOtherProperty?: number;
  public ReMortgageHomeImprovementDetails: string;
  public ReMortgageSchoolFeesOrPensionDetails: string;
  public ReMortgageBusinessInvestmentDetails: string;
  public ReMortgageAdditionalPropertyDetails: string;
  public ReMortgageOutrightPropertyPurchaseDetails: string;
  public ReMortgageCostsAndFeesDetails: string;
  public RedemptionMortgageOnOtherPropertyDetails: string;

  deserialize(input: any): this {
    Object.assign(this, input);

    return this;
  }
}
